import { EnforceShiftsOverviewV2 } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { JobList } from './JobList';
import { ShiftListLegacy } from './ShiftListLegacy';

export const JobListManager = () => {
  const isEnabled = useFeatureFlag(EnforceShiftsOverviewV2);

  if (isEnabled) {
    return <JobList />;
  }

  return <ShiftListLegacy />;
};
